import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "SupplierEnterpriseGlobalListPage" */
	'pages/supplier/SupplierEnterprise/SupplierEnterpriseDirectoryListPage'));

export default [{ component, exact: true, path: '/supplier_enterprises_directory' }];
